import React, { useState, useEffect } from 'react';
import { useAdobeDataLayer, PageNames } from '../../hooks/useAdobeDataLayer';
import './PartnerStoriesPage.css';
import Header from '../../components/layout/Header';
import PartnerStoriesHero from '../../components/Redesign/PartnerStoriesHero';
import PartnerStoriesLogos from '../../components/Redesign/PartnerStoriesLogos';
import Intro from '../../components/Redesign/Intro';
import PartnerStoriesTabs from '../../components/Redesign/PartnerStoriesTabs';
import PartnerStoriesDetail from '../../components/Redesign/PartnerStoriesDetail';
import ContactBanner from '../../components/Redesign/ContactBanner';
import brandJourneyBg from 'url:../../assets-optimized/redesign/partnerStories/bring_your_own_brand.jpg';
import brandJourneyAvif from 'url:../../assets-optimized/redesign/partnerStories/bring_your_own_brand.avif';
import brandJourneyWebp from 'url:../../assets-optimized/redesign/partnerStories/bring_your_own_brand.webp';

const PartnerStoriesPage = () => {
  const [activeBrandTab, setActiveBrandTab] = useState(0);
  const { sendPageView } = useAdobeDataLayer();

  useEffect(() => {
    sendPageView(PageNames.PartnerStories);
  }, [sendPageView]);

  return (
    <div className='partner-stories-page'>
      <PartnerStoriesHero />
      <PartnerStoriesLogos />
      <Intro>
          We partner with leading global brands to turn complex challenges into repeatable successes. See how on- and offsite media solutions come together across our global network to {' '}
          <span className='audience-pill cs-intro-pill'>
            <span className='cs-lightning-wrapper'>
              <svg viewBox='0 0 24 24' className='cs-lightning-bolt'>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" fill="none" stroke="currentColor" strokeWidth="2" />
              </svg>
            </span>
            deliver powerful results.
          </span>
      </Intro>
      <PartnerStoriesTabs 
        activeBrandTab={activeBrandTab} 
        setActiveBrandTab={setActiveBrandTab} 
      />
      <PartnerStoriesDetail activeBrandTab={activeBrandTab} />
      <ContactBanner title="Bring your brand into the journey" bgImage={brandJourneyBg} bgImageAvif={brandJourneyAvif} bgImageWebp={brandJourneyWebp} />
    </div>
  );
};

export default PartnerStoriesPage;
